import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { supabase } from "@/lib/supabase";
import { useAuth } from "@/contexts/AuthContext";

export function CoordinatorMessageNotifier() {
  const { user, activeWorkspaceId } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const navigateRef = useRef(navigate);
  navigateRef.current = navigate;
  const locationRef = useRef(location);
  locationRef.current = location;
  const activeWsRef = useRef(activeWorkspaceId);
  activeWsRef.current = activeWorkspaceId;

  useEffect(() => {
    if (!user?.id) return;

    const channel = supabase
      .channel("coord-msg-notifier")
      .on(
        "postgres_changes" as never,
        { event: "INSERT", schema: "public", table: "coordinator_messages" },
        async (payload: { new: { sender_user_id: string; body: string; thread_id: string } }) => {
          const msg = payload.new;
          if (msg.sender_user_id === user.id) return;
          if (locationRef.current.pathname === "/app/coordinator/chat") return;

          if (activeWsRef.current) {
            const { data: thread } = await supabase
              .from("coordinator_threads")
              .select("organization_id")
              .eq("id", msg.thread_id)
              .single();
            if (thread?.organization_id !== activeWsRef.current) return;
          }

          const preview = msg.body.length > 80 ? `${msg.body.slice(0, 80)}…` : msg.body;

          toast("Mensaje de coordinación", {
            description: preview,
            duration: Infinity,
            action: {
              label: "Ver",
              onClick: () => navigateRef.current("/app/coordinator/chat"),
            },
          });
        },
      )
      .subscribe();

    return () => {
      void supabase.removeChannel(channel);
    };
  }, [user?.id]);

  return null;
}
